/* New Athletes (test) — discipline filter chips for sections/new-athletes.liquid. */
(function () {
  var chips = document.getElementById("nat-chips");
  var grid = document.getElementById("nat-roster");
  var count = document.getElementById("nat-count");
  if (!chips || !grid) return;
  var cards = grid.querySelectorAll(".nat-card");
  chips.addEventListener("click", function (e) {
    var b = e.target.closest("[data-pick]");
    if (!b) return;
    var pick = b.getAttribute("data-pick");
    var buttons = chips.querySelectorAll(".nat-chip");
    for (var i = 0; i < buttons.length; i++) {
      var on = buttons[i] === b;
      buttons[i].classList.toggle("is-on", on);
      buttons[i].setAttribute("aria-pressed", on ? "true" : "false");
    }
    var n = 0;
    cards.forEach(function (c) {
      var show = pick === "all" || c.getAttribute("data-sport") === pick;
      c.hidden = !show;
      if (show) n++;
    });
    if (count) count.textContent = n + (n === 1 ? " athlete" : " athletes");
  });
})();
